import {GaugeComponent} from 'react-gauge-component'

export const Gauge = ({value, subtitle, subArcs, customLabels, ticks, min=0, max=100}) => {

    


return (
<div className="mx-5 column-center">
    <GaugeComponent 
        minValue={min}
        maxValue={max}
        className='w-gauge'
        type='semicircle'
        arc={{
            width: 0.15,
            subArcs,
            padding: 0.005,
            cornerRadius: 0,
        }}
        pointer={{type: "arrow", elastic: true}}
        value={value}
        labels={{
            valueLabel: {
                style: {fontSize: "40px", fill: 'black', textShadow: null, whiteSpace: 'pre-line'},
                formatTextValue: (value) => value
            },
            tickLabels: {
                type: 'outer',
                ticks,
                defaultTickValueConfig: {
                    formatTextValue: (val) => customLabels[val] || null,
                    style: {fill: 'black'}
                },
                defaultTickLineConfig: {hide: true}

            }
        }}

    />
    <label className="f-05 bold">{subtitle} </label>
    </div>
)
}